<template>
  <div id="AzaHesabha" dir="rtl">
    <Card back>
      <template v-slot:header>
        <h3>حسابهای بانکی</h3>
        <hr />
      </template>
      <template v-slot:content v-if="this.$store.state.renderComponentGrid">
        <div class="container-fluid">
          <div @click="Add()" class="row" v-if="!AddMode">
            <a>
              <h3><i class="text-success fas fa-plus"></i></h3>
            </a>
          </div>
          <div v-if="!AddMode" class="row">
            <BnpGrid :propsRows="rows" :propsColumn="columns" :action="true">
              <template slot="action-slot" slot-scope="props">
                <a href="javascript:;" class="mr-2 badge" @click="OnDelete(props.props)"><span class="hover-danger fas fa-trash-alt text-secondary" style="font-size: 15px"></span></a>
                <a href="javascript:;" class="mr-2 badge" @click="OnEdit(props.props)" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo"><span class="hover-warning fas fa-marker text-secondary" style="font-size: 15px"></span></a>
              </template>
              <template slot="empty-results"> حساب بانکی برای نمایش وجود ندارد </template>
            </BnpGrid>
          </div>
          <div v-else class="row">
            <form action="" @submit.prevent="this.$ValidForm(this)" :id="$route.name" name="myform">
              <div class="text-center mr-3 ml-3">
                <div class="row">
                  <div class="col-12 col-md-4 text-right">
                    <small id="LblHesabNo"> شماره حساب </small>
                    <input v-mask="'##########'" type="text" class="form-control text-left" v-model="DataAxios.HesabNo" @keypress="$ValidNumber($event, 10)" />
                  </div>
                  <div class="col-12 col-md-4 text-right">
                    <small id="LblCardNo">شماره کارت</small>
                    <input v-mask="'####-####-####-####'" placeholder="____-____-____-____" type="text" class="form-control text-left" v-model="DataAxios.CardNo" />
                  </div>
                  <div class="col-12 col-md-4 text-right">
                    <small id="LblShebaNo">شماره شبا</small>
                    <input v-mask="'IR########################'" placeholder="IR" type="text" class="form-control text-left" v-model="DataAxios.ShebaNo" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-4 text-right">
                    <small id="LblTblBankId" for="TblBankId">نام بانک</small>
                    <!-- <combo @ValueResult="ValueResultBankName" :IsLoad="false" :ActionUrl="'GettblBank'"  :Op_TextDefult="'بانک را انتخاب نمایید'"></combo> -->
                    <!-- <combo v-if="Editmode == true"  :@ValueResult="ValueResultIsLoad" :IsDefault="true" :Op_TextDefult="'بانک را انتخاب نمایید'"></combo> -->
                    <SearchableCombo
                      v-if="Editmode == true"
                      :edit="false"
                      :grp="11"
                      :defaultvalue="DataAxios.TblBankId"
                      @ResultCombo="ValueResultIsLoad"
                      :queryString="{ id: 24 }"
                      :rownumintable="3"
                      :action="'TblCombo/GettblBank'"
                      :method="'GET'"
                      :idinput="'GettblBank'"
                      :keyItem="'GettblBank'"
                      :disabled="false"
                      :IsDefault="true"
                    >
                    </SearchableCombo>
                    <!-- <combo v-else :ActionUrl="'GettblBank'" :IsDisabled="false" :IsLoad="false" :IdEditMode="DataAxios.TblBankId" @ValueResultIsLoad="ValueResultIsLoad" :IsDefault="false" :Op_TextDefult="'بانک را انتخاب نمایید'"></combo> -->
                    <SearchableCombo v-else :edit="false" :grp="11" @ResultCombo="ValueResultIsLoad" :queryString="{ id: 24 }" :rownumintable="3" :action="'TblCombo/GettblBank'" :method="'GET'" :idinput="'GettblBank'" :keyItem="'GettblBank'" :disabled="false" :IsDefault="true"> </SearchableCombo>
                  </div>
                  <div class="col-12 col-md-4 text-right">
                    <small id="LblShomarePas">شماره پس انداز</small>
                    <!-- <input  v-mask="this.$session.get('UserInfo').codeShobe.trim()+'-##-########'" :placeholder="this.$session.get('UserInfo').codeShobe.trim()+'-'" type="text" class="form-control text-left" dir="ltr" v-model="DataAxios.ShomarePas"> -->
                    <!-- <combo v-if="Editmode !== true" :ActionUrl="'GetSearchTaahodatPas'" :IsDisabled="false" :IsLoad="false" :IdEditMode="DataAxios.TblTaahodatIdPas" :Params="this.AzaId" @ValueResultIsLoad="SearchTaahodatPas" :IsDefault="false" :Op_TextDefult="'حساب را انتخاب نمایید'"></combo> -->

                    <SearchableCombo
                      v-if="Editmode == true"
                      :edit="false"
                      :grp="11"
                      :defaultvalue="DataAxios.TblTaahodatIdPas"
                      @ResultCombo="SearchTaahodatPas"
                      :queryString="{ id: AzaId }"
                      :rownumintable="3"
                      :action="'TblCombo/GetSearchTaahodatPas'"
                      :method="'GET'"
                      :idinput="'TaahodatIdPas'"
                      :keyItem="'TaahodatIdPas'"
                      :disabled="false"
                      :IsDefault="true"
                    ></SearchableCombo>

                    <SearchableCombo v-else :edit="false" :grp="11" @ResultCombo="SearchTaahodatPas" :queryString="{ id: AzaId }" :rownumintable="3" :action="'TblCombo/GetSearchTaahodatPas'" :method="'GET'" :idinput="'TaahodatIdPas'" :keyItem="'TaahodatIdPas'" :disabled="false" :IsDefault="true">
                    </SearchableCombo>

                    <!-- <combo v-else :ActionUrl="'GetSearchTaahodatPas'" :IsDisabled="false" :IsLoad="true" :IdEditMode="DataAxios.TblTaahodatIdPas" :Params="this.AzaId" @ValueResult="SearchTaahodatPas" :IsDefault="false" :Op_TextDefult="'حساب را انتخاب نمایید'"></combo> -->
                  </div>
                  <div class="col-12 col-md-4 text-right">
                    <small id="LblNameSahebHesab">صاحب حساب/کارت</small>
                    <input type="text" class="form-control text-right" v-model="DataAxios.NameSahebHesab" />
                  </div>
                </div>

                <div v-if="Editmode == true">
                  <button-edit-data @Success="Search" @Cancel="AddMode = false" class="mb-3 mr-2" :DataParanet="DataAxios"></button-edit-data>
                </div>
                <div v-else>
                  <button-save-data @Success="Search" @Cancel="AddMode = false" class="mb-3 mr-2" @emptysaved="ResetForm" :DataParanet="DataAxios"> </button-save-data>
                </div>
              </div>
            </form>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import ButtonEditData from '@/components/BnpButtons/BtnEditData.vue'
import ButtonSaveData from '@/components/BnpButtons/BtnSaveData.vue'

export default {
  data() {
    return {
      DataAxoisColumns: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: 'frmAzaHesabHa',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      DataAxiosDelete: {
        ArryfildValue: '',
        Method: 'Delete',
        Action: 'AzaHesabHa',
        Token: this.$session.get('Token'),
      },
      Sweet: ['حذف اطلاعات', 'آیا از حذف این اطلاعات اطمینان دارید ؟', 'warning', false],
      DataAxios: null,
      DataAxiosSearch: { ArryfildValue: {} },
      posts: null,
      rows: [],
      columns: [],
      Data: [
        {
          Id: 1,
          TblAzaId: 203580,
          TblBankId: 1,
          HesabNo: '',
          CardNo: '',
          ShebaNo: '',
          Active: false,
          ZamanInsert: '1400/08/20 08:59:02',
          TblUserGrpIdInsert: 1,
          ZamanLastEdit: '1400/08/20 09:01:31',
          TblUserGrpIdLastEdit: 1,
          InfoDes: '',
          TblTaahodatIdPas: null,
          WwwHasBeenChanged: true,
          WwwtblAzaHesabId: null,
          SmstblAzaHesabId: null,
          SmsHasBeenChanged: true,
          NameSahebHesab: '',
          RamzKart: 0,
          Ramz2Kart: 0,
          Cvv2: '',
          TarixEngheza: '',
        },
      ],
      EditData: [
        {
          Id: 1,
          TblAzaId: 203580,
          TblBankId: 1,
          HesabNo: '',
          CardNo: '',
          ShebaNo: '',
          Active: false,
          ZamanInsert: '1400/08/20 08:59:02',
          TblUserGrpIdInsert: 1,
          ZamanLastEdit: '1400/08/20 09:01:31',
          TblUserGrpIdLastEdit: 1,
          InfoDes: '',
          TblTaahodatIdPas: null,
          WwwHasBeenChanged: true,
          WwwtblAzaHesabId: null,
          SmstblAzaHesabId: null,
          SmsHasBeenChanged: true,
          NameSahebHesab: '',
          RamzKart: 0,
          Ramz2Kart: 0,
          Cvv2: '',
          TarixEngheza: '',
        },
      ],
      Editmode: false,
      AddMode: false,
      AzaId: 0,
    }
  },
  props: ['TblAzaId'],
  components: { BnpGrid, Card, SearchableCombo, ButtonEditData, ButtonSaveData },
  mounted: function () {
    try {
      if (this.TblAzaId != undefined) {
        this.Data[0].TblAzaId = this.TblAzaId
      }
      this.columns = this.$NewGridColumns(this.DataAxoisColumns, true, false, true, true)
      this.$store.state.columns = this.columns
      this.Search()
    } catch (error) {
      console.log(error)
    }
  },
  created() {
    let list = []
    list.push(JSON.parse(JSON.stringify(this.Data[0])))
    this.DataAxios = list[0]
    this.AcceessButton(this.$route.name)
  },
  methods: {
    SearchTaahodatPas(value) {
      try {
        this.DataAxios.TblTaahodatIdPas = value.id
      } catch (error) {
        console.log(error)
      }
    },
    ValueResultIsLoad(value) {
      try {
        console.log(value)
        this.DataAxios.TblBankId = value.id
      } catch (error) {
        console.log(error)
      }
    },
    Search() {
      try {
        this.DataAxiosSearch.Action = this.$route.name + '/Index?id=' + this.Data[0].TblAzaId
        this.DataAxiosSearch.Method = 'Get'
        this.$PostData(this.DataAxiosSearch)
          .then((data) => {
            if (data.length > 0) {
              this.posts = data
              if (this.posts != null) {
                this.rows = this.posts
                this.$store.state.renderComponentGrid = false
                this.$nextTick(() => {
                  this.$store.state.renderComponentGrid = true
                })
              }
            } else {
              this.rows = []
            }
          })
          .finally(() => {
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          })
      } catch (error) {
        console.log(error)
      }
    },
    OnEdit(data) {
      this.$store.state.OldDataForLog = JSON.stringify(data)
      this.EditData[0] = data
      this.DataAxios = JSON.parse(JSON.stringify(data))
      this.AddMode = true
      this.Editmode = true
      this.$store.state.renderComponent = false
      this.$nextTick(() => {
        this.$store.state.renderComponent = true
      })
    },
    OnDelete(data) {
      this.$store.state.OldDataForLog = JSON.stringify(data)
      this.DataAxiosDelete.ArryfildValue = { id: data.Id }
      this.$DeleteData(this.DataAxiosDelete, this.Sweet)
      this.$store.state.renderComponentGrid = false
      this.$nextTick(() => {
        this.$store.state.renderComponentGrid = true
      })
    },

    AcceessButton(RoutName) {
      try {
        var menuBtn = this.$session.get('Menu')
        var GetParentRoute = menuBtn.filter((z) => z.RouteName == RoutName)
        var ButtonsRoute = menuBtn.filter((z) => z.ParentId == GetParentRoute[0].id)
        this.$session.set(RoutName, ButtonsRoute)
      } catch (error) {
        console.log(error)
      }
    },
    Add() {
      this.AddMode = true
      this.Editmode = false
      this.DataAxios = JSON.parse(JSON.stringify(this.Data[0]))
      this.AzaId = this.Data[0].TblAzaId
    },
    ResetForm(value) {
      this.DataAxios = value
    },
  },
}
</script>
<style scoped></style>
